import { render, staticRenderFns } from "./exactList.vue?vue&type=template&id=2a1b3307&"
import script from "./exactList.vue?vue&type=script&lang=js&"
export * from "./exactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports